import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import SMStream from '../streams/SMStream2';
import { fetchRoundEventsForStageKey } from 'dash-front/actions/events';
import eventify from 'Eventify';
import moment from 'moment';
let eventsPreview = (tournament, events) => {
    let widgets = [
        ..._.filter(events, e => eventify(e).isFT()).map(({ eventId }) => ({
            groupTitle: 'Finished matches',
            groupKey: `${eventId}`,
            name: 'MatchFinished',
            props: {
                eventId
            },
            key: `mp-${eventId}`
        })),

        ..._.filter(events, e => eventify(e).isComing() || eventify(e).isLive()).map(({ eventId }) => ({
            name: 'PreMatchStatsSMWidget',
            groupTitle: 'Upcoming matches H2H',
            groupKey: `${eventId}`,

            props: {
                eventId
            },
            key: `h2h-${eventId}`
        }))
    ];

    return widgets;
};

let roundWidgets = (tournament, season, stage, round, events) => {
    return [
        {
            name: 'RoundMatchesSMWidget',
            groupTitle: `Round ${round}`,

            props: {
                tournamentId: tournament.id,
                stageId: stage.id,
                round
            }
        },
        {
            name: 'RoundMatchesSMWidget',
            groupTitle: `Round ${round} grouped by day`,
            groupKey: `Round ${round}-grounped`,
            props: {
                tournamentId: tournament.id,
                stageId: stage.id,
                round,
                groupByDay: true
            }
        },
        ..._.chain(events)
            .groupBy(e => moment(e.startDate).format('YYYY-MM-DD'))
            .keys()
            .map(date => {
                return {
                    name: 'TodayMatchesSMWidget',
                    groupTitle: `Matchday ${moment(date).format('D MMM')}`,
                    groupKey: `${date + '_' + tournament.id}`,
                    props: {
                        tournamentId: tournament.id,
                        stageId: stage.id,
                        date: date
                    },
                    key: `${date + '_' + tournament.id}`
                };
            })
            .value()
    ];
};

class StageRoundSMB extends React.Component {
    constructor(props, context) {
        super(props, context);
    }

    componentDidMount = () => {};

    componentWillReceiveProps = nextProps => {};

    render() {
        let {
            tournament,
            season,
            stage,
            events,
            params: { round }
        } = this.props;
        return (
            <div>
                <SMStream smWidgets={roundWidgets(tournament, season, stage, round, events)} title={`Matchdays`} />
                <SMStream smWidgets={eventsPreview(tournament, events)} title={`Round events`} />
            </div>
        );
    }
}

export default connect(
    (state, props) => {
        let { stageId, round } = props.params;
        let ids = _.get(state, `query.entities[${fetchRoundEventsForStageKey(stageId, round)}]`, []);
        let events = _.get(state, `query.entities.events`, []);
        return {
            tournament: _.get(state.smBrowser, 'tournament'),
            stages: _.get(state.smBrowser, 'season.stages', []),
            events: ids.map(id => events[id]),
            stage: _.chain(state.smBrowser)
                .get('season.stages', [])
                .find(s => +s.id === +props.params.stageId)
                .value()
        };
    },
    dispatch => ({
        dispatch
    })
)(StageRoundSMB);



/** WEBPACK FOOTER **
 ** ../src/dash/front/components/sm/pages/TournamentRoundSMB.js
 **/